import { Bug, TriangleAlert, UserPlus, Volume2 } from 'lucide-react';
import React from 'react';

import { cn } from '../../lib/utils';

interface Activity {
  id: string;
  type: 'bug' | 'user' | 'notification' | 'subscription';
  message: string;
  timestamp: string;
  icon?: React.ElementType;
}

interface ActivityFeedProps {
  title: string;
  activities: Activity[];
  className?: string;
}

const getActivityIcon = (type: Activity['type']) => {
  switch (type) {
    case 'bug':
      return Bug;
    case 'user':
      return UserPlus;
    case 'subscription':
      return Volume2;
    default:
      return TriangleAlert;
  }
};

export const ActivityFeed: React.FC<ActivityFeedProps> = ({
  title,
  activities,
  className
}) => {
  return (
    <div className={cn("bg-card border border-border rounded-xl", className)}>
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      </div>
      <div className="divide-y divide-border">
        {activities.map((activity) => {
          const Icon = activity.icon || getActivityIcon(activity.type);
          return (
            <div key={activity.id} className="p-4 hover:bg-muted/30 transition-colors">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon className="h-4 w-4 text-muted-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground">{activity.message}</p>
                  <p className="text-xs text-muted-foreground mt-1">{activity.timestamp}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
